import { EvaluatedBackgroundMusicOptions } from '@videosmart/player-template';
import { RootState } from '../models';
import { selectEvaluatedBackgroundMusic } from './selectEvaluatedBackgroundMusic';

export const selectBackgroundMusic = (state: RootState): EvaluatedBackgroundMusicOptions | undefined => {
	const backgroundMusic = state.data.isLoaded ? state.data.template.backgroundMusicOptions : undefined;
	return backgroundMusic ? selectEvaluatedBackgroundMusic(state) : undefined;
};
